import React, { useState } from "react";
import CustomInputField from "../../../../common/CustomInputField";

function BankDetail({ value, submitForm, handleInput_Bank }) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitForm) {
      setLoading(true);
      await submitForm(value);
      setLoading(false);
    }
  };

  return (
    <form className="tbl-captionn p-3" onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xl-4 mb-3">
          <label className="form-label font-weight-bold">Account Holder Name</label>
          <CustomInputField
            type="text"
            placeholder="Account Holder Name"
            value={value?.bank_account_name || value?.name || ""}
            onChange={handleInput_Bank}
            id="bank_account_name"
            name="bank_account_name"
          />
        </div>
        <div className="col-xl-4 mb-3">
          <label className="form-label font-weight-bold">Bank Name</label>
          <CustomInputField
            type="text"
            placeholder="Bank Name"
            value={value?.bank_name || ""}
            onChange={handleInput_Bank}
            id="bank_name"
            name="bank_name"
          />
        </div>
        <div className="col-xl-4 mb-3">
          <label className="form-label font-weight-bold">IFSC Code</label>
          <CustomInputField
            type="text"
            placeholder="IFSC Code"
            value={value?.bank_ifsc || value?.ifsc || ""}
            onChange={handleInput_Bank}
            id="bank_ifsc"
            name="bank_ifsc"
          />
        </div>
        <div className="col-xl-4 mb-3">
          <label className="form-label font-weight-bold">Account Number</label>
          <CustomInputField
            type="text"
            placeholder="Account Number"
            value={value?.bank_account_number || value?.bankAccountnum || ""}
            onChange={handleInput_Bank}
            id="bank_account_number"
            name="bank_account_number"
          />
        </div>
        <div className="col-xl-4 mb-3">
          <label className="form-label font-weight-bold">Account Type</label>
          <CustomInputField
            type="text"
            placeholder="Account Type (Savings / Current)"
            value={value?.account_type || value?.AccountType || ""}
            onChange={handleInput_Bank}
            id="account_type"
            name="account_type"
          />
        </div>
      </div>
      <div className="mt-3">
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Saving..." : "Save Bank Details"}
        </button>
      </div>
    </form>
  );
}

export default BankDetail;
